import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { Input, InputPhone } from 'components/fields'
import {
  OrganizationOverview,
  FinancialData
} from 'components/sections/organizations'
import { LogoUpload } from 'components/misc'


export default class OfficeDetails extends Component {
  static propTypes = {
    isRegion: PropTypes.bool,
    displaySettings: PropTypes.bool,
    organizationStates: PropTypes.array,
    updateOrganizationState: PropTypes.func,
    data: PropTypes.object,
    showFinancialData: PropTypes.bool,
    showPrfDisc: PropTypes.bool
  }

  render() {
    const { isRegion, displaySettings, showFinancialData, showPrfDisc } = this.props

    return (
      <div>
        <div className="row">
          <div className="col-xs-6">
            <LogoUpload {...this.props} />
          </div>
          <div className="col-xs-6">
            <OrganizationOverview
              updateOrganizationState={this.props.updateOrganizationState}
              organizationStates={this.props.organizationStates}
              data={this.props.data}
              displaySettings={displaySettings}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-6">
            <div className="row">
              <div className="col-xs-6">
                <Input
                  label="Organization name"
                  intlKey="label.organization_name"
                  name="name"
                  disabled={isRegion}
                />
                {/* <InputPhone label='Phone number' intlKey='label.phone_number' name='phoneNumber' /> */}
                <Input label="Email" intlKey="label.email" name="email" />
              </div>
            </div>
            <div className="row">
              <div className="col-xs-6">
                <InputPhone
                  label="Phone number"
                  intlKey="label.phone_number"
                  name="phoneNumber"
                />
              </div>
            </div>
            <div className="row">
              <div className="col-xs-6">
                <InputPhone label="Fax" intlKey="label.fax" name="faxNumber" />
              </div>
            </div>
          </div>
          <div className="col-xs-6">
            {showFinancialData && <FinancialData showPrfDisc={showPrfDisc} />}
          </div>
        </div>
      </div>
    )
  }
}
